module.exports = __webpack_public_path__ + "static/media/Image_not_available.6ce9535f.png";